import { Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CheckStatus = ({ status}) => {
const { t } = useTranslation(['common', 'messages'])
return (
    <Box sx={{ mb: 2 }}>
      <Paper variant="colorPrimary" sx={{ p: 2, boxShadow: 'none' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, minHeight: 40 }}>
          <Typography
            variant="title"
            color="primary"
            sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', fontSize: 22 }}
          >
            {t('common:status')}:
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: 'text.secondary', display: 'flex', alignItems: 'center', fontSize: 20 }}
          >
            {t(`common:${status}`)}
          </Typography>
        </Box>
      </Paper>
    </Box>
);
};

export default CheckStatus;
